import ContentLoader from 'react-content-loader'
import COLORS from '@web-ui-kit/colors'

const SelectGroupSkeleton = () => {
  return (
    <ContentLoader
      backgroundColor={COLORS.NEUTRAL_200}
      foregroundColor={COLORS.WHITE}
      style={{ width: '100%' }}
      viewBox={'0 0 550 400'}
    >
      {/* Title */}
      <rect height='20' rx='5' ry='5' width='200' x='175' y='100' />

      {/* Subtitle */}
      <rect height='15' rx='4' ry='4' width='300' x='125' y='130' />

      {/* Radio buttons */}
      <circle cx='150' cy='220' r='10' />
      <rect height='20' rx='5' ry='5' width='80' x='170' y='210' />

      <circle cx='310' cy='220' r='10' />
      <rect height='20' rx='5' ry='5' width='80' x='330' y='210' />

      {/* Finalize Button */}
      <rect height='40' rx='10' ry='10' width='360' x='95' y='270' />

      {/* Link */}
      <rect height='20' rx='5' ry='5' width='120' x='215' y='320' />
    </ContentLoader>
  )
}

export default SelectGroupSkeleton
